// extracted by mini-css-extract-plugin
export default {"mainBox":"style_mainBox__U+OVv","optionsContainer":"style_optionsContainer__ULQNQ","optionBox":"style_optionBox__L2L8n"};